var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivitySelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2783_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1905 6.66663V4.33329C14.1905 3.39987 14.1905 2.93316 14.0088 2.57664C13.849 2.26304 13.5941 2.00807 13.2805 1.84828C12.9239 1.66663 12.4572 1.66663 11.5238 1.66663H5.19047C4.25705 1.66663 3.79034 1.66663 3.43382 1.84828C3.12022 2.00807 2.86525 2.26304 2.70546 2.57664C2.5238 2.93316 2.5238 3.39987 2.5238 4.33329V10.6666C2.5238 11.6 2.5238 12.0668 2.70546 12.4233C2.86525 12.7369 3.12022 12.9918 3.43382 13.1516C3.79034 13.3333 4.25705 13.3333 5.19047 13.3333H7.5238M10.8571 12.5L12.5238 14.1666L16.2738 10.4166M10.1905 18.3333H16.5238C17.4572 18.3333 17.9239 18.3333 18.2805 18.1516C18.5941 17.9918 18.849 17.7369 19.0088 17.4233C19.1905 17.0668 19.1905 16.6 19.1905 15.6666V9.33329C19.1905 8.39987 19.1905 7.93316 19.0088 7.57664C18.849 7.26304 18.5941 7.00807 18.2805 6.84828C17.9239 6.66663 17.4572 6.66663 16.5238 6.66663H10.1905C9.25705 6.66663 8.79034 6.66663 8.43382 6.84828C8.12022 7.00807 7.86525 7.26304 7.70546 7.57664C7.5238 7.93316 7.5238 8.39987 7.5238 9.33329V15.6666C7.5238 16.6 7.5238 17.0668 7.70546 17.4233C7.86525 17.7369 8.12022 17.9918 8.43382 18.1516C8.79034 18.3333 9.25705 18.3333 10.1905 18.3333Z",
    stroke: "#0054B6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2783_1047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.857178)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySelected);
export default __webpack_public_path__ + "static/media/ActivitySelected.cdb43fc8a0c9054a164daf6a10a2d991.svg";
export { ForwardRef as ReactComponent };